import { t } from "../../i18n";
import { setInsuranceEmail } from "../../lib/queries";
import { ScheduledEmail } from "./ScheduledEmail";

/**
 * Who hears, on the 1st, what last month's crews cost the two policies.
 *
 * Workers comp is reported to the fund monthly and liability is audited at the
 * end of the policy year, both on what the crews were actually paid. So on the
 * 1st the people who pay them are emailed last month's figure, split by crews
 * with and without their own cover, and the liability year so far (ADR 0275).
 */
export function InsuranceEmail() {
  return (
    <ScheduledEmail
      title={t("Monthly insurance email")}
      blurb={
        <>
          {t(
            "At 7am on the 1st of every month, everyone below is emailed the workers comp and general liability owed on the crews paid the month before, and how the liability year is tracking. Nobody chosen means it is not sent.",
          )}
        </>
      }
      functionName="insurance-email"
      sendLabel={t("Send last month’s now")}
      read={(settings) => ({
        from: settings?.insurance_email_from_profile_id ?? null,
        to: settings?.insurance_email_profile_ids ?? [],
      })}
      save={setInsuranceEmail}
      sentNote={(result) =>
        t("Sent to {n} people.", { n: result.sent?.length ?? 0 })
      }
    />
  );
}
